import Panel from '../panel/Panel';
import { observer } from 'mobx-react-lite';
import { useTranslation } from "react-i18next";
import CartWitnessingContent from './CartWitnessingContent';


const CartsPage = observer(() => {
    const { t } = useTranslation();
    return (
        <Panel
            title={t("carts")}
            headerItems={[]}>
            <CartWitnessingContent />

        </Panel >
    );
});

export default CartsPage;